import BankingForm from "components/Banking/banking-form"
import React from "react"
import * as url from "../../helpers/url_helper"
import {
    getMerchantGroupBankingDetail,
    addNewMerchantGroupBanking,
    clearMerchantGroupBankingDetail,
    manageMerchantGroupBanking,
    toggleMerchantGroupBankingDefault,
    checkMerchantGroupBankingStatus,
} from "store/merchant-group/actions"

// Stable selector functions to prevent rerenders
const bankingListSelector = (state) => state.merchantGroup.merchantGroupBankingList || []
const bankingErrorSelector = (state) => state.merchantGroup.bankingError
const bankingCreationSuccessSelector = (state) => state.merchantGroup.bankingCreationSuccess

const MerchantGroupBankingForm = (props) => {
    return (
        <BankingForm
            {...props}
            entityType="merchantGroup"
            entityName="Merchant Group"
            // Banking actions
            getBankingListAction={getMerchantGroupBankingDetail}
            addBankingAction={addNewMerchantGroupBanking}
            manageBankingAction={manageMerchantGroupBanking}
            toggleDefaultBankingAction={toggleMerchantGroupBankingDefault}
            checkBankingStatusAction={checkMerchantGroupBankingStatus}
            clearBankingListAction={clearMerchantGroupBankingDetail}
            // Redux selectors
            bankingListSelector={bankingListSelector}
            bankingErrorSelector={bankingErrorSelector}
            bankingCreationSuccessSelector={bankingCreationSuccessSelector}
            // API configuration
            apiContextUri={url.MANAGE_MERCHANT_GROUP_BANKING}
            toggleApiContextUri={url.TOGGLE_MERCHANT_GROUP_BANKING_STATUS}
            toggleDefaultApiContextUri={url.TOGGLE_MERCHANT_GROUP_BANKING_DEFAULT}
            checkStatusApiContextUri={url.CHECK_MERCHANT_GROUP_BANKING_STATUS}
        />
    )
}

export default MerchantGroupBankingForm